/**
 * Created by JasonChou on 16/12/12.
 */
import {
  savePageHeight as savePageHeightApi,
  savePageWidth as savePageWidthApi
} from '../../apis/common'


// 修改选中控件大小
export const changeControlSize = ({ dispatch }, left, top, width, height, record) => {
  dispatch('CHNAGE_CONTROL_SIZE', left, top, width, height, record);
};

// 取消选中
export const popSelectedControl = ({ dispatch }, control) => {
  dispatch('POP_SELECTED_CONTROLS', control);
};

// 添加选中
export const appendSelectedControl = ({ dispatch }, control) => {
  console.time('添加选中')
  dispatch('APPEND_SELECTED_CONTROLS', [control]);
  console.timeEnd('添加选中')
};

// 重新选中
export const selectControl = ({ dispatch }, control) => {
  if (control) {
    console.time('重新选中')
    dispatch('UPDATE_SELECTED_CONTROLS', [control]);
    console.timeEnd('重新选中')
  }
};
export const selectControlWithId = ({ dispatch }, control) => {
  if (control) {
    dispatch('SELECT_CONTROL_WITH_ID', [control])
  }
}

export const selectControlItems = ({ dispatch }, ...controls) => {
  const all = controls.every(Boolean)
  if (all) {
    dispatch('SELECT_CONTROL_ITEMS', controls);
  }
}

//新建一个控件
export const newControl = ({ dispatch, state }, controlDefine, style, isAdd) => {
  dispatch('NEW_CONTROL', controlDefine, style, state.editor.controlDefinesMap, isAdd);
  dispatch('CHANGE_CONTROLS_INDEX', controlDefine.type);
};

export const syncControls = ({ dispatch }, res, defineMaps) => {
  dispatch('SYNC_CONTROLS', res, defineMaps)
}

//新建控件数组
export const newControls = ({ dispatch }, controlDefineList, isSaveToSelected = true) => {
  dispatch('NEW_CONTROLS', controlDefineList, isSaveToSelected);
};

// 重新选中
export const selectControls = ({ dispatch }, controls) => {
  dispatch('UPDATE_SELECTED_CONTROLS', controls);
};

// 删除所有选中的
export const removeSelectedControls = ({ dispatch }) => {
  dispatch('REMOVE_SELECTED_CONTROLS');
  dispatch('CLEAR_SELECTED_CONTROLS');
};

// 删除控件数组
export const removeSomeControls = ({ dispatch }, controls) => {
  dispatch('REMOVE_SOME_CONTROLS', controls);
};

export const addControlsMap = ({ dispatch }, control) => {
  dispatch('ADD_CONTROL_MAP', control);
};

// 交换控件
export const exchangeNodes = ({ dispatch }, node1, node2, nodes) => {
  dispatch('SWITCH_SPIDER_CONTROLS', node1, node2, nodes, false)
}
export const switchNodes = ({ dispatch }, node1, node2, nodes, updateIds = false) => {
  dispatch('SWITCH_CONTROL', node1, node2, nodes, updateIds)
}

export const clearStack = ({ dispatch }) => {
  dispatch('CLEAR_STACK')
}

export const addStack = ({ dispatch }, name) => {
  dispatch('ADD_STACK', name)
}
// 追加控件到某个元素
export const moveNodeAsLastNode = ({ dispatch }, node1, node2, nodes) => {
  dispatch('MOVE_NODE_AND_APPEND_NODE', node1, node2, nodes)
}

//清除所有选中的
export const clearSelectedControls = ({ dispatch }) => {
  dispatch('CLEAR_SELECTED_CONTROLS');
};

export const copySelectedControls = ({ dispatch }) => {
  dispatch('COPY_SELECTED_CONTROLS');
};

export const cutSelectedControls = ({ dispatch }) => {
  dispatch('CUT_SELECTED_CONTROLS');
};

export const pasteSelectedControls = ({ dispatch, state }, defineMaps) => {
  dispatch('PASTE_SELECTED_CONTROLS', defineMaps);
};

export const selectAllControls = ({ dispatch }) => {
  dispatch('SELECT_ALL_CONTROLS');
};

export const moveSelectedControlsByKey = ({ dispatch }, key) => {
  dispatch('MOVE_SELECTED_CONTROLS', key);
};

export const moveToSelectedControls = ({ dispatch }, x, y) => {
  dispatch('MOVE_TO_SELECTED_CONTROLS', x, y);
};

//拖拽结束时
export const moveEndSelectedControls = ({ dispatch }, control, x, y) => {
  dispatch('MOVE_END_SELECTED_CONTROLS', control, x, y);
};

export const updateSelectedControlEvents = ({ dispatch }, events) => {
  dispatch('UPDATE_SELECTED_CONTROL_EVENTS', events);
};

export const updateSelectedControlProp = ({ dispatch }, propKey, key, value, controlName, callback) => {
  let newValue = value
  if (!value) {
    newValue = value
  } else {
    newValue = JSON.parse(JSON.stringify(value));
  }
  dispatch(
    'UPDATE_SELECTED_CONTROL_PROP',
    propKey,
    key,
    newValue,
    controlName,
    callback
  )
};

export const clearModifiedControl = ({ dispatch }, propKey, key, value) => {
  dispatch('CLEAR_MODIFIED_CONTROL');
}

export const recordModifiedControl = ({ dispatch }) => {
  dispatch('RECORD_MODIFIED_CONTROL');
}
export const clearHeartControls = ({ dispatch }) => {
  dispatch('CLEAR_HEARTBEAT_CONTROL')
}

export const heartHistory = ({ dispatch }, controls) => {
  dispatch('HEART_HISTORY', controls)
}
export const clearHeartHistory = ({ dispatch }) => {
  dispatch('CLEAR_HEART_HISTORY')
}

export const recordControlActions = ({ dispatch }, control, type, recursive) => {
  console.time('RECORD_CONTROL_ACTIONS');
  dispatch('RECORD_CONTROL_ACTIONS', control, type, recursive)
  // console.log('type', type, 'control', control.id, '是否递归', recursive);
  console.timeEnd('RECORD_CONTROL_ACTIONS');
}

export const updateChildrenIds = ({ dispatch }, childrenIds) => {
  dispatch('UPDATE_CHILDRENIDS', childrenIds)
}

export const updateCustomAttrs = ({ dispatch }, control, k, v) => dispatch('UPDATE_CUSTOM_ATTRS', control, k, v);
export const updateCustomSrc = ({ dispatch }, control, k, v) => dispatch('UPDATE_CUSTOM_SRC', control, k, v);
export const updateCustomStyle = ({ dispatch }, control, k, v) => dispatch('UPDATE_CUSTOM_STYLE', control, k, v);

export const updateSelectedControlsProp = ({ dispatch }, propKey, key, value) => {
  const newValue = JSON.parse(JSON.stringify(value));
  dispatch('UPDATE_SELECTED_CONTROLS_PROP', propKey, key, newValue);
};

export const supperSelectedControlsProp = ({ dispatch }, propKey, key, value) => {
  const newValue = JSON.parse(JSON.stringify(value));
  dispatch('SUPPER_SELECTED_CONTROLS_PROP', propKey, key, newValue);
};

export const updateSelectedControlOptions = ({ dispatch }, options) => {
  dispatch('UPDATE_SELECTED_CONTROL_OPTIONS', options);
};

//撤销操作
export const cancelSelectedControlOpera = ({ dispatch }) => {
  dispatch('CANCEL_SELECTED_CONTROL_OPERA');
};

//重做的操作
export const resumeSelectedControlOpera = ({ dispatch }) => {
  dispatch('RESUME_SELECTED_CONTROL_OPERA');
};

export const savePageWidth = ({ dispatch, state }, screen_width) => {
  savePageWidthApi(state.app.appInfo._id, state.page.pageInfo.page_id, screen_width).then((res) => {
    dispatch('UPDATE_PAGE_INFO', state.page.pageInfo.page_id, { screen_width })
  });
};

export const savePageHeight = ({ dispatch, state }, screen_height) => {
  savePageHeightApi(state.app.appInfo._id, state.page.pageInfo.page_id, screen_height).then((res) => {
    dispatch('UPDATE_PAGE_INFO', state.page.pageInfo.page_id, { screen_height })
  });
};

//组合控件
export const groupSelectedControls = ({ state, dispatch }) => {
  dispatch('GROUP_SELECTED_CONTROLS', state.editor.groupControlDefine)
};

//un组合控件
export const unGroupSelectedControls = ({ state, dispatch }) => {
  dispatch('UN_GROUP_SELECTED_CONTROLS', state.editor.groupControlDefine)
};

//新增widget
export const newWidget = ({ state, dispatch }, controls, tempBinding, bind, type, name, rows, columns, form_config, customStyleArr, thems, layout) => {
  dispatch('NEW_WIDGET', controls, tempBinding, bind, type, name, rows, columns, form_config, customStyleArr, thems, layout)
};

export const updateWidget = ({ state, dispatch }, widget) => {
  dispatch('UPDATE_WIDGET', widget)
};


// 更换图片
export const updateImage = ({ dispatch }, image, key, setIndex) => {
  dispatch('UPDATE_IMAGE', image, key, setIndex)
};
export const updateErrControlId = ({ dispatch }, value) => {
  dispatch('UPDATE_ERR_CONTROLID', value);
};

export const addElementControls = ({ dispatch }, elements, defineMaps, url) => {
  dispatch('ADD_ELEMENTS', elements, url);
  dispatch('PASTE_SELECTED_CONTROLS', defineMaps);
  dispatch('CLEAR_SELECTED_CONTROLS');
}

export const updateSelectControlsStyle = ({ dispatch }, style, reset) => {
  dispatch('UPDATE_STYLES', style, reset)
}



// WEBPACK FOOTER //
// ./src/vuex/actions/page_actions.js